import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import { postSubmit } from '@ui-seeker/utils'

import { isLoadingCommonFilters, commonFiltersValue, isSystemBusy } from '@signals'
import { WEBBACK_V2_API } from '@constants'
import { isEmptyDynamicAssortment } from "../@signals";


export default function useDynamicAssortmentFilters() {

    const data = useSignal([])
    const siteWarnings = useSignal([])
    const lastUpdateDate = useSignal(null)

    useEffect(() => {
        if (isLoadingCommonFilters.value) batch(() => {
            postSubmit(`${WEBBACK_V2_API}/custom-dash/dynamic-assort/context`, commonFiltersValue.value)
                .then(res => {
                    if (!res.tableData?.length)
                        isEmptyDynamicAssortment.value = true
                    data.value = res.tableData
                    siteWarnings.value = res.sitesWarnings
                    lastUpdateDate.value = res.lastUpdateDate
                    isLoadingCommonFilters.value = false
                })
                .catch(() => {
                    isSystemBusy.value = true
                    isLoadingCommonFilters.value = false
                })
        })
    }, [isLoadingCommonFilters.value])

    return {
        data: data.value,
        siteWarnings: siteWarnings.value,
        lastUpdateDate: lastUpdateDate.value,
    }
}